const home = {
  // Hero
  'hero.brand': 'NOREN',
  'hero.brandSub': '日本の不動産',
  'hero.title': '日本で家を持とう',
  'hero.titleItalic': '— 複雑な手続きは不要です。',
  'hero.subtitle': '海外の買い主様のために、日本の不動産を探査・購入・リノベーション・運営まで一貫サポート。英語対応。現地に来る必要はありません。',
  'hero.pricePoint': 'エントリー価格50万円～。現金取引のみ。',
  'hero.ctaPrimary': '物件を見る',
  'hero.ctaSecondary': 'サービスを見る',

  // Trust bar
  'trust.entry': '50万円～',
  'trust.entrySub': 'エントリー価格',
  'trust.entryDetail': '現金購入',
  'trust.fx': '30–40%',
  'trust.fxSub': '実質為替ディスカウント',
  'trust.fxDetail': '2021年以降、USD/EUR/GBP買い主向け',
  'trust.yield': '8–12%',
  'trust.yieldSub': '目標純利益率',
  'trust.yieldDetail': '保守的試算であり保証ではありません',
  'trust.remote': '100%',
  'trust.remoteSub': 'リモート完結',
  'trust.remoteDetail': '日本に来る必要はありません',

  // Services
  'services.sectionLabel': 'サービス',
  'services.title': '4つのサービス。',
  'services.titleItalic': 'それぞれ単独で選択可能。',
  'services.titleLine3': '段階的に組み合わせられます。',
  'services.intro': '購入支援から始め、必要に応じてリノベーション、賃貸開始、フルマネジメントを追加。強制パッケージや縛りはありません。',
  'services.showLess': '閉じる',
  'services.whatsIncluded': '含まれるもの',
  'services.step1': '01',
  'services.step1Title': '購入支援のみ',
  'services.step1Price': '支援手数料48万円～',
  'services.step1Desc': '販売中物件の掘り起こし、現地立ち入り調査、価格交渉、クロージングまで一括対応。バイリンガル契約書、構造報告書、リノベーション事前見積もりを支払い前にご提示します。',
  'services.step1Inc1': '販売中物件の掘り起こし',
  'services.step1Inc2': '現地構造調査',
  'services.step1Inc3': 'バイリンガル契約書レビュー',
  'services.step1Inc4': 'クロージング調整',
  'services.step1Inc5': 'リノベーション事前見積もり',
  'services.step2': '02',
  'services.step2Title': 'ターンキー・リノベーション',
  'services.step2Price': 'リノベ費用＋20%プロジェクト管理手数料',
  'services.step2Desc': '社内チームと審査済み地元業者が、設計・許認可・施工をフルマネジメント。居住仕様または賃貸仕様でお引き渡し。週次写真報告、コスト追跡、想定外ゼロを目指します。',
  'services.step2Inc1': '設計・許認可対応',
  'services.step2Inc2': '業者管理',
  'services.step2Inc3': '資材調達',
  'services.step2Inc4': '週次進捗報告',
  'services.step2Inc5': '最終検査・引き渡し',
  'services.step3': '03',
  'services.step3Title': '賃貸事業スタート',
  'services.step3Price': '開始費用60万円～',
  'services.step3Desc': '民泊・旅館業許可、消防法対応、家具家電配置、プロ写真撮影、OTA掲載、現地価格戦略まで一括対応。初日から予約が入る状態でスタートします。',
  'services.step3Inc1': '民泊または旅館業許可取得',
  'services.step3Inc2': '消防法適合対応',
  'services.step3Inc3': 'インテリア・備品配置',
  'services.step3Inc4': 'プロフェッショナル写真撮影',
  'services.step3Inc5': 'OTA掲載・価格設定',
  'services.step4': '04',
  'services.step4Title': '運営代行',
  'services.step4Price': '短期賃貸収入の20%、または長期賃貸収入の5%',
  'services.step4Desc': 'ゲスト対応、清掃手配、メンテナンス・修繕、2ヶ月ごとの法定報告、税務申告代行までフル対応。毎月英語のP&Lレポートをお届けします。',
  'services.step4Inc1': 'ゲスト対応（英語・日本語）',
  'services.step4Inc2': '清掃・リネン手配',
  'services.step4Inc3': 'メンテナンス・修繕対応',
  'services.step4Inc4': '2ヶ月ごとの法定報告',
  'services.step4Inc5': '年次税務申告代行',
  'services.step4Inc6': '月次P&Lレポート（英語）',

  // Listings
  'listings.sectionLabel': '販売中物件',
  'listings.title': '販売中物件',
  'listings.titleItalic': 'あらゆる予算帯で。',
  'listings.intro': '現在販売中の日本の物件をご紹介。価格帯は50万円～。毎週新しい物件を追加しています。',
  'listings.sampleNote': 'これらは代表例です。実際のリストは毎週変わります。',

  // Co-ownership promo (home)
  'coPromo.sectionLabel': '共同保有マッチング',
  'coPromo.title': 'コストを分け合う。',
  'coPromo.titleItalic': '名義は自分のまま。',
  'coPromo.body': 'NORENは、共同購入に適した物件について、審査済みの共同保有者をご紹介します。各所有者は、自分の名義で直接持分を取得します。NORENは資金の集約・運用・収益保証は行いません。',
  'coPromo.example': '例',
  'coPromo.exampleTitle': '小田原町家ゲストハウス',
  'coPromo.exampleAllIn': 'トータル',
  'coPromo.exampleProgress': '4口のうち2口が確定',
  'coPromo.exampleSpots': '残り2口',

  // Process
  'process.sectionLabel': '購入の流れ',
  'process.title': '4ステップ。',
  'process.titleItalic': '現地に来る必要はありません。',
  'process.intro': '初回面談から賃貸稼働物件になるまで。各ステップは英語で対応。書類はすべて翻訳します。',
  'process.step1': '01',
  'process.step1Title': '予算と目的をお聞きします',
  'process.step1Desc': '居住、リノベーション、賃貸収益—ご希望とご不安をお聞きします。この正直な対話が、探査期間を半分に縮めます。',
  'process.step2': '02',
  'process.step2Title': '物件選定と現地調査',
  'process.step2Desc': 'チームが現地を訪問し、動画で室内を撮影。構造問題の指摘、設備チェック、リノベーション見積もりを行います。 glossy なパンフレットではなく、実際の数字付きショートリストをご提示します。',
  'process.step3': '03',
  'process.step3Title': 'リモートで購入・リノベーション',
  'process.step3Desc': '契約、公証、銀行送金、登記—すべて英語対応。社内チームがリノベーションを管理。FEFTA、税務、市役所の2026年要件もすべて代行します。',
  'process.step4': '04',
  'process.step4Title': '居住または収益化',
  'process.step4Desc': '移住、季節的な滞在、賃貸稼働—ご希望に応じて運営代行も可能。毎月英語のP&Lレポートを受け取れます。距離はもはや問題ではありません。',

  // Renovation stories
  'reno.sectionLabel': '/ リノベーション事例',
  'reno.title': 'ビフォー・アフター。',
  'reno.titleItalic': '私たちのチームが実現するもの。',
  'reno.intro': 'リノベーションしたすべての物件を記録しています。これらは代表例です—各プロジェクトには独自の範囲、工期、予算があります。',
  'reno.beforeLabel': 'Before',
  'reno.beforeDesc': '四国の放棄された空き家。骨組みは健全。配線・配管・断熱・内装の全面刷新が必要。',
  'reno.afterLabel': 'After',
  'reno.afterDesc': '同じ物件、6ヶ月後。旅館業許可付きのターンキーゲストハウス。家具・写真撮影・掲載済み。現在稼働中。',

  // Returns
  'returns.sectionLabel': '/ 収益シミュレーション',
  'returns.title': '一つ、正直で保守的な',
  'returns.titleItalic': '計算例。',
  'returns.intro': 'これは約束でも予測でもありません。購入前にモデリングした実際の物件です。在庫のすべての物件が同じ計算を通っています。',
  'returns.badge': '地方の古民家＋旅館業許可',
  'returns.badgeSub': '365日賃貸可能',
  'returns.purchase': '購入価格',
  'returns.renovation': 'リノベーション（全面刷新＋設備）',
  'returns.licence': '旅館業許可＋消防法対応',
  'returns.furnish': '備品・写真・OTA掲載設定',
  'returns.allIn': 'トータル投資額',
  'returns.gross': '年間総売上',
  'returns.grossNote': '平均6,575円/泊、稼働率55%',
  'returns.costs': '年間運営費',
  'returns.costsNote': '清掃、メンテナンス、管理、税務',
  'returns.noi': '年間純営業利益（NOI）',
  'returns.yieldLabel': 'トータル投資額に対する純利益率',
  'returns.important': '重要：',
  'returns.importantText': 'これは単一の代表例であり、約束や予測ではありません。すべての物件は購入前に個別モデリングされます。実際の収益は立地、物件状態、リノベーション範囲、許認可状況、市場需要により異なります。ショートリストの各物件とともに、完全なモデルを共有します。',

  // Honest FAQ
  'faq.sectionLabel': '/ 徹底した正直さ',
  'faq.title': '厳しい真実。',
  'faq.titleItalic': '率直にお答えします。',
  'faq.intro': '海外の買い主が一円でも支払う前に知るべきこと。途中で気づくのではなく、最初からお伝えします。',
  'faq.q1': '非居住者でも住宅ローンは組めますか？',
  'faq.a1': 'いいえ。日本の銀行は、現地保証人と日本国内の安定収入証明がない限り、非居住外国人に融資しません。日本に居住・勤務していない場合、現金のみで計画してください。海外の買い主が住宅ローンを組めた事例は私たちは見たことがありません。',
  'faq.q2': '不動産を買うとビザがもらえますか？',
  'faq.a2': 'いいえ。日本では不動産購入に「ゴールデンビザ」や投資家居住権はありません。家を持っても滞在権は発生しません。90日を超える滞在には通常のビザが必要です。誤解されている方が多いため、購入後ではなく今お伝えしています。',
  'faq.q3': 'Airbnbで何日まで貸せますか？',
  'faq.a3': '民泊法では、無許可の短期賃貸は年間180泊までです。無制限の賃貸収入を得るには旅館業許可が必要で、これには特定の用途地域、消防法適合、24時間対応の現地管理人が必要です。書類は私たちが提出します。上限がないふりはしません。',
  'faq.q4': 'なぜあの家は50万円なのですか？',
  'faq.a4': '放棄され、構造的に損傷していることが多く、人口減少で賃貸需要の薄い町にあり、全面改装が購入価格の3～5倍かかるからです。「買わない方がいい」が正解の場合もあります。私たちは、購入前に稼働率、改装費、現実的な賃貸収入をモデリングします。見栄えのいい例だけを選んでいません。',

  // CTA / Inquiry
  'cta.sectionLabel': 'お問い合わせ',
  'cta.title': '日本で家を探す',
  'cta.titleItalic': 'あなたの予算に合わせて。',
  'cta.intro': '予算、目的、タイムラインをお聞かせください。販売中の物件から厳選ショートリストをお送りします—実際の数字、実際の写真、正直な評価付きで。',
  'cta.firstName': '名',
  'cta.lastName': '姓',
  'cta.email': 'メールアドレス',
  'cta.country': '居住国',
  'cta.budget': '予算帯（円）',
  'cta.goal': '購入目的',
  'cta.message': 'メッセージ（任意）',
  'cta.messagePlaceholder': 'タイムライン、希望エリア、質問などをお書きください...',
  'cta.privacy': '個人情報は一切共有しません。通常の返信時間：48時間以内。',
};

export default home;